import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Icon,
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardRoomSearchUX = (props: any) => {
    return(
      <div>
        <div
          className="ui accordion blue  fluid raised segment"
          id="CardRoomSearchUX-div-1"
          style={{boxShadow: "none"}}>
          
          <div
            id="CardRoomSearchUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <label
              id="CardRoomSearchUX-label-3"
              style={{fontSize: "1.2rem", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Find a room" : "ค้นหาห้อง"}
            </label>
            <div
              id="CardRoomSearchUX-div-4"
              style={{cursor: "pointer"}}>
              {}
              <Icon
                className="red large"
                id="CardRoomSearchUX-Icon-5"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
          <div
            className="ui divider"
            id="CardRoomSearchUX-div-6">
            
          </div>
          <div
            className="ui form"
            id="CardRoomSearchUX-div-7">
            
            <FormGroup
              id="CardRoomSearchUX-FormGroup-8"
              inline={true}>
              <FormField
                id="CardRoomSearchUX-FormField-10"
                inline={true}
                width={2}>
                <label
                  id="CardRoomSearchUX-label-15"
                  style={{textAlign: "right", width: "100%"}}>
                  {props.languageUX === "en" ? "Room/Bed Number" : "เลขห้อง/เตียง"}
                </label>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-11"
                inline={true}
                width={5}>
                <Input
                  id="CardRoomSearchUX-Input-16"
                  onChange={props.onChangeRoomNo}
                  value={props.roomNo}>
                </Input>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-12"
                inline={true}
                width={2}>
                <label
                  id="CardRoomSearchUX-label-17"
                  style={{textAlign: "right", width: "100%"}}>
                  {props.languageUX === "en" ? "Type of ward" : "ประเภทหอผู้ป่วย"}
                </label>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-13"
                inline={true}
                width={5}>
                <Dropdown
                  fluid={true}
                  id="CardRoomSearchUX-Dropdown-18"
                  onChange={props.onChangeWardType}
                  options={props.wardTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.wardType}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-14"
                inline={true}
                width={2}>
                <Button
                  color={"blue"}
                  fluid={true}
                  id="CardRoomSearchUX-Button-19"
                  loading={props.loading}
                  onClick={props.onSearch}>
                  {props.languageUX === "en" ? "Search" : "ค้นหา"}
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRoomSearchUX-FormGroup-9"
              inline={true}>
              <FormField
                id="CardRoomSearchUX-FormField-20"
                inline={true}
                width={2}>
                <label
                  id="CardRoomSearchUX-label-25"
                  style={{textAlign: "right", width: "100%"}}>
                  {props.languageUX === "en" ? "Room type" : "ประเภทห้อง"}
                </label>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-21"
                inline={true}
                width={5}>
                <Dropdown
                  fluid={true}
                  id="CardRoomSearchUX-Dropdown-26"
                  onChange={props.onChangeRoomType}
                  options={props.roomTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.roomType}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-22"
                inline={true}
                width={2}>
                <label
                  id="CardRoomSearchUX-label-27"
                  style={{textAlign: "right", width: "100%"}}>
                  {props.languageUX === "en" ? "Room status" : "สถานะห้อง"}
                </label>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-23"
                inline={true}
                width={5}>
                <Dropdown
                  fluid={true}
                  id="CardRoomSearchUX-Dropdown-28"
                  onChange={props.onChangeRoomStatus}
                  options={props.roomStatusOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.roomStatus}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-24"
                inline={true}
                width={2}>
                <Button
                  color={"teal"}
                  fluid={true}
                  id="CardRoomSearchUX-Button-29"
                  onClick={props.onClear}>
                  {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                </Button>
              </FormField>
            </FormGroup>
            <div
              id="CardRoomSearchUX-div-32"
              style={{marginBottom: "1rem"}}>
              
              <Table
                data={props.roomList}
                getTrProps={props.onGetTrProps}
                headers="เลขห้อง/เตียง,ประเภทหอผู้ป่วย,ประเภทห้อง,สถานะห้อง"
                id="CardRoomSearchUX-Table-33"
                keys="room_no,ward_name,room_name,room_status"
                showPagination={false}
                style={{width: "100%",  height: "400px"}}>
              </Table>
            </div>
            <FormGroup
              id="CardRoomSearchUX-FormGroup-34">
              <FormField
                id="CardRoomSearchUX-FormField-35"
                inline={true}
                width={14}>
              </FormField>
              <FormField
                id="CardRoomSearchUX-FormField-36"
                inline={true}
                width={2}>
                <Button
                  color={"green"}
                  fluid={true}
                  id="CardRoomSearchUX-Button-37"
                  onClick={props.onSelect}>
                  {props.languageUX === "en" ? "choose" : "เลือก"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
    )
}


export default CardRoomSearchUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:44:46 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui accordion blue  fluid raised segment"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาห้อง",
          "valueEN": "Find a room"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-label-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Icon",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Icon-5"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-div-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขห้อง/เตียง",
          "valueEN": "Room/Bed Number"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-label-15"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Input",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Input-16"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRoomNo"
        },
        "value": {
          "type": "code",
          "value": "props.roomNo"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทหอผู้ป่วย",
          "valueEN": "Type of ward"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-label-17"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Dropdown",
      "parent": 13,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Dropdown-18"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeWardType"
        },
        "options": {
          "type": "code",
          "value": "props.wardTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.wardType"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Button",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "code",
          "value": "\"blue\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Button-19"
        },
        "loading": {
          "type": "code",
          "value": "props.loading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทห้อง",
          "valueEN": "Room type"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Dropdown",
      "parent": 21,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Dropdown-26"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRoomType"
        },
        "options": {
          "type": "code",
          "value": "props.roomTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.roomType"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะห้อง",
          "valueEN": "Room status"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-label-27"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Dropdown",
      "parent": 23,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Dropdown-28"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRoomStatus"
        },
        "options": {
          "type": "code",
          "value": "props.roomStatusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.roomStatus"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Button",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "code",
          "value": "\"teal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Button-29"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1rem\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 33,
      "name": "Table",
      "parent": 32,
      "props": {
        "data": {
          "type": "code",
          "value": "props.roomList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetTrProps"
        },
        "headers": {
          "type": "value",
          "value": "เลขห้อง/เตียง,ประเภทหอผู้ป่วย,ประเภทห้อง,สถานะห้อง"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Table-33"
        },
        "keys": {
          "type": "value",
          "value": "room_no,ward_name,room_name,room_status"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",  height: \"400px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormGroup-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Button",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก",
          "valueEN": "choose"
        },
        "color": {
          "type": "code",
          "value": "\"green\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRoomSearchUX-Button-37"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelect"
        },
        "size": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 37,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": false,
  "name": "CardRoomSearchUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 65
}

*********************************************************************************** */
